import { datadogRum } from '@datadog/browser-rum';
import { getConfig } from '../config/configuration';

export function trackPolicyViewsRum(policyDetailsId: string, policyNumber: string): void {
  const config = getConfig();

  if (!config.ddRumEnabled) {
    return;
  }

  datadogRum.addAction('policy_viewed', {
    policyDetailsId,
    policyNumber
  });
}
